import { closeModal, openModal } from '../common/simpleModal';

class MenuModal {
    constructor() {
        this.modalLinks = document.querySelectorAll('a[data-target="modal"]');
        this.modal = document.querySelector('.menu-modal');

        if (!this.modal) return;

        this.init();
    }

    init() {
        this.modalLinks.forEach(link => {
            link.addEventListener('click', (event) => {
                event.preventDefault();
                this.openMenuModal(link);
            });
        });

        if (this.modal) {
            const closeButton = this.modal.querySelector('.close-modal');
            if (closeButton) {
                closeButton.addEventListener('click', () => {
                    closeModal('.menu-modal');
                });
            }
        }
    }

    openMenuModal(link) {
        const title = link.getAttribute('data-modal-title') || link.textContent.trim();
        const content = link.getAttribute('data-modal-content') || '';
        const buttonText = link.getAttribute('data-button-text') || '';
        const buttonUrl = link.getAttribute('data-button-url') || '#';

        // Atualizar título
        const titleElement = this.modal.querySelector('.menu-modal-title');
        if (titleElement) {
            titleElement.textContent = title;
        }

        // Atualizar conteúdo
        const contentElement = this.modal.querySelector('.menu-modal-content');
        if (contentElement) {
            contentElement.textContent = content;
        }

        // Atualizar botão
        const buttonElement = this.modal.querySelector('.menu-modal-button');
        if (buttonElement) {
            if (buttonText && buttonUrl) {
                buttonElement.href = buttonUrl;
                const buttonTextElement = buttonElement.querySelector('.menu-modal-button-text');
                if (buttonTextElement) {
                    buttonTextElement.textContent = buttonText;
                }
                buttonElement.classList.remove('hidden');
            } else {
                buttonElement.classList.add('hidden');
            }
        }

        openModal('.menu-modal');
    }
}

if (document.querySelectorAll('a[data-target="modal"]').length > 0) {
    new MenuModal();
}
